import {
  PURCHASED_SEAT_STATUSES,
  buildPurchaserSeatClusters,
  getPurchaserClusterKey,
  isPurchaserSeat,
} from '../../../../../utilities/purchaserSeatClusters'

export { PURCHASED_SEAT_STATUSES }

export function isPurchasedSeatIdentity(identity) {
  return (
    Boolean(getPurchaserClusterKey(identity)) &&
    PURCHASED_SEAT_STATUSES.includes(identity?.onSaleStatus)
  )
}

/** clusterKey -> seatId[] */
export function buildPurchaserClusters(seatIdentityById = {}) {
  const purchaserKeyToSeatIds = buildPurchaserSeatClusters(seatIdentityById)
  const seatIdToPurchaserKey = {}

  Object.entries(seatIdentityById).forEach(([seatId, identity]) => {
    if (!isPurchasedSeatIdentity(identity)) return
    const key = getPurchaserClusterKey(identity)
    if (!key) return
    seatIdToPurchaserKey[seatId] = key
  })

  return { seatIdToPurchaserKey, purchaserKeyToSeatIds }
}

export function getPurchaserClusterSeatIds(
  seatId,
  seatIdentityById = {},
  clusters = null
) {
  const { purchaserKeyToSeatIds } =
    clusters ?? buildPurchaserClusters(seatIdentityById)
  const identity = seatIdentityById[seatId]
  const clusterKey = getPurchaserClusterKey(identity)
  if (!clusterKey) return seatId ? [seatId] : []

  return purchaserKeyToSeatIds[clusterKey] || (seatId ? [seatId] : [])
}

export function formatSeatLocationLabel(seat) {
  if (!seat) return ''
  return [
    seat.sectionNumber != null && seat.sectionNumber !== ''
      ? `Sec ${seat.sectionNumber}`
      : null,
    seat.rowNumber != null && seat.rowNumber !== ''
      ? `Row ${seat.rowNumber}`
      : null,
    seat.seatNumber != null && seat.seatNumber !== ''
      ? `Seat ${seat.seatNumber}`
      : null,
  ]
    .filter(Boolean)
    .join(' - ')
}
